import { Button, Input, Switch } from "antd";
import { PlusIcon, SearchIcon } from "../../../../../atoms/CustomIcons";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../config/hooks";
import { removeServiceLineListing } from "../../ducks/actions";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      status: string;
    }>
  >;
  companyId: string | undefined;
  value: string;
  archived: boolean;
  showArchived: React.Dispatch<React.SetStateAction<boolean>>;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, companyId, value, setValue, archived, showArchived } =
    props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onChange = (checked: boolean) => {
    dispatch(removeServiceLineListing());
    showArchived(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "archived",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: "active",
      }));
    }
  };

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search"
            allowClear
            value={value}
            onChange={(e) => setValue(e?.target?.value?.toLowerCase())}
          />
        </div>
        <div className="right_service_filter">
          <div className="filterToggle">
            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={archived} />
                Show archived
              </div>
            </div>
          </div>
          <div className="filterDownload">
            <Button
              icon={<PlusIcon />}
              type="primary"
              onClick={() =>
                navigate(`/company-settings/create-service-line/${companyId}`)
              }
            >
              Create service line
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
